/**
 * Column definitions for the Lambda resource tables.
 * Extracted from UpgradeMedicPage.tsx — preserves all existing behavior.
 */
import React from 'react';
import { Box, Checkbox, SpaceBetween } from '@amzn/awsui-components-core';
import { LambdaFunction } from '../types';

/** Base column definitions (no selection checkbox). */
export const createLambdaColumnDefinitions = (eolVersionsSet: Set<string>) => [
  {
    id: 'name',
    header: 'Function Name',
    cell: (item: LambdaFunction) => (
      <SpaceBetween size="xxxs">
        <Box fontWeight="bold">{item.name}</Box>
        <Box fontSize="body-s" color="text-body-secondary">
          {item.arn}
        </Box>
      </SpaceBetween>
    )
  },
  {
    id: 'type',
    header: 'Type',
    cell: (item: LambdaFunction) => item.type,
    width: 100
  },
  {
    id: 'runtime',
    header: 'Runtime',
    cell: (item: LambdaFunction) => {
      return item.runtime;
    },
    width: 120
  },
  {
    id: 'region',
    header: 'Region',
    cell: (item: LambdaFunction) => item.region,
    width: 120
  }
];

/** Column definitions WITH leading checkbox — for "Manually created" and "Manual Deployed Stacks" pipelines. */
export const createLambdaColumnDefinitionsWithSelect = (
  eolVersionsSet: Set<string>,
  selectedLambdaIdsRef: React.MutableRefObject<Set<string>>,
  toggleLambdaSelection: (id: string) => void,
  _selectionVersion: number
) => [
  {
    id: 'select',
    header: '',
    cell: (item: LambdaFunction) => <Checkbox checked={selectedLambdaIdsRef.current.has(item.id)} onChange={() => toggleLambdaSelection(item.id)} />,
    width: 50
  },
  ...createLambdaColumnDefinitions(eolVersionsSet)
];
